module.exports = __webpack_public_path__ + "static/2020全球零售科技创新TOP50-再惠-cfb860d1042341f09de07fb89bfb114f.png";